/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Records_Table_LabelInputs */

const en_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Save Records Table`)
};

const fr_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau des enregistrements de sauvegarde automatique`)
};

const de_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabelle zum automatischen Speichern von Datensätzen`)
};

const it_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabella dei record di salvataggio automatico`)
};

const ru_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица автоматического сохранения записей`)
};

const es_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de registros guardados automáticamente`)
};

const zh_cn2_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动保存记录表`)
};

const ja_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動保存レコードテーブル`)
};

const hi_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड तालिका को स्वतः सहेजें`)
};

const pt_pt2_automatic_save_records_table_label = /** @type {(inputs: Automatic_Save_Records_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela de registros de salvamento automático`)
};

/**
* | output |
* | --- |
* | "Auto Save Records Table" |
*
* @param {Automatic_Save_Records_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_records_table_label = /** @type {((inputs?: Automatic_Save_Records_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Records_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_records_table_label(inputs)
	if (locale === "de") return de_automatic_save_records_table_label(inputs)
	if (locale === "it") return it_automatic_save_records_table_label(inputs)
	if (locale === "ru") return ru_automatic_save_records_table_label(inputs)
	if (locale === "es") return es_automatic_save_records_table_label(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_records_table_label(inputs)
	if (locale === "ja") return ja_automatic_save_records_table_label(inputs)
	if (locale === "hi") return hi_automatic_save_records_table_label(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_records_table_label(inputs)
	return en_automatic_save_records_table_label(inputs)
});